<pia3-language-selector 
[selectorMode]="selectorMode"
(languageSelected)="_languageSelected($event)"
></pia3-language-selector>
